import React from "react";
import { useState, useEffect } from "react";
import SalespersonSidebar from "./SalespersonSidebar";
import Editor from 'react-simple-wysiwyg';
import { Helmet } from "react-helmet";
import './classes/AddNews.css';
import { useParams } from 'react-router-dom';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import { configData } from "../config";
import Loading from './Loading';
import ViewSuccessStoryPage from "./ViewSuccessStoryPage";

const EditSuccessStoryPage = () => {

    const initialFormData = {
        title: '',
        field_name: '',
        summary: '',
        body: '',
        field_image_success_story: '',
        field_delete_image:0,
        placements: [{ placement_page: '', placement_sort_order: '1'}],
		deleted_placements: [],
        courses: [],
        deleted_courses: [],
        url_alias: ''
    };

    const [formData,setFormData] =useState(initialFormData);
    const [isLoading, setIsLoading] = useState(true);
    const [toggle, setToggle] = useState(2);
    const [errors, setErrors] = useState({});
    const [showSummary, setShowSummary] = useState(false);
    const [useRichEditor, setUseRichEditor] = useState(true);
    const [PreviewFields, setPreviewFields] = useState(false);
    const [previewData, setPreviewData] = useState(null);
    const[userLoggedInRoles,setUserLoggedInRoles] = useState([]);

    const [savedData, setSavedData] = useState(initialFormData);
    const [viewChanges, setViewChanges] = useState(false);
    const [originalData, setOriginalData] = useState(null);
    const [formDataSnapshot, setFormDataSnapshot] = useState(null);

    const [imageUploadError, setImageUploadError] = useState('');
    const [tempImage, setTempImage] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null); 
    const [courses, setCourses] = useState([]);
    const [pages, setPages] = useState([]);
    const [disabled, setDisabled] = useState(false);
    const [buttontext, setButtonText] = useState("Save");
    const domainName = window.location.hostname;
    const loggedin_drupal_uid = localStorage.getItem('drupal_uid');
    const drupal_domain_url = configData.DRUPAL_DOMAIN_URL;
    const location  = useLocation();
    const drupal_uid = localStorage.getItem('drupal_uid');  
    var loggedin_domain = drupal_domain_url;
    if(localStorage.getItem('loggedin_domain')) {
        loggedin_domain = localStorage.getItem('loggedin_domain');
    } 
    const {tab} = useParams();
    const {sid} = useParams();
    const loggedin_uid = localStorage.getItem('uid');
    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const domain_url = configData.DOMAIN_URL;

    const path = location.pathname.replace(/^\/+/, "");
    const [page, setPage] = useState(null);

    function updateToggle(id){
        setToggle(id);
        if(id == 1) { 
             window.location.href = "/" + page.url_slug;
            //navigate("/node/success-story/"+sid+"/view");
        }
        if(id == 2) { 
           // navigate("/node/success-story/"+sid+"/edit");
			navigate("/"+ page.url_source+"/edit");									   
        }
    }

    const getPageTitle = () => {
        const title = originalData?.title || "";
        if (toggle === 1) {
            return title ? title : "Success Stories";
        } else if (toggle === 2) {
            return title ? `Edit Success Story ${title}` : "Edit Success Story";
        }

        return "Edit Success Story"; 
    };

    const getPageHeading = () => {
        const title = originalData?.title || "";
        if (toggle === 2) {
            return (
            <>
                Edit Success Story {title}
            </>
            );
        }
        return null;
    };

    useEffect(() => {
        Promise.all([
            getuserloggedinroles(), 
            getPageData(),
            getplacementlist()
        ]).then(() => {
            setIsLoading(false);
            if(tab == "view") {
                setToggle(1);
            }
            if(tab == "edit") {
                setToggle(2);
            }
        })
    } ,[tab]);

    async function getPageData() {
        try {
            setIsLoading(true);
            const response = await fetch(
                app_url+'successstory/geteditpagedata?path='+path,
                {
                    method: "GET",
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
            setPage(responsedata.data);
                  setFormData({
                ...responsedata.data,
                placements: (responsedata.data.placements || []).map(item => ({
                    ...item,
                    isExisting: true,
                })),
                courses: (responsedata.data.courses || []).map(item => ({
                    ...item,
                    isExisting: true,
                    // Remember the persisted product so a changed row can
                    // replace (not duplicate) it on save.
                    original_product_id: item.product_id,
                })),
                deleted_courses: [],
            });
            setOriginalData({
                ...responsedata.data,
                placements: responsedata.data.placements || [],
                courses: responsedata.data.courses || [],
            });
            setCourses(responsedata.data.available_courses || []);
            } 
        } catch (err) {
            
        }finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
        }
    
    }

    async function getplacementlist() {
        try {
            const response = await fetch(
                app_url+'node/getnodepages',
                {
                    method: "GET",
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setPages(responsedata.data.result);
            } 
        } catch (err) {
            
        }
    }

    async function getuserloggedinroles() {
        try {
            setIsLoading(true);
            const response = await fetch(
                app_url+'viewprofile/getuserloggedinrolesid',
                {
                    method: "GET",
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setUserLoggedInRoles(responsedata.data.roles);
            } 
        } catch (err) {
            
        }finally {
            setIsLoading(false); 
        }
    } 

     const cleanHtmlOutput = (html) => {
        if (!html) return '';

        let cleaned = html;

        cleaned = cleaned.replace(/<\s*(p|div|h[1-6])[^>]*>\s*(<br\s*\/?>|\&nbsp;|\s)*\s*<\/\1\s*>/gi, '');

        cleaned = cleaned.replace(/<br\s*\/?>/gi, '');

        const textOnly = cleaned.replace(/&nbsp;|\s|<[^>]*>/g, '').trim();

        return textOnly.length === 0 ? '' : html.trim();
    };

    const onEditorChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value,
        }));
    };

    // COURSE section handlers.
    const handleAddCourse = () => {
        setFormData((prev) => ({
            ...prev,
            courses: [...(prev.courses || []), { product_id: '', placement_sort_order: '1', isExisting: false }],
        }));
    };

    const handleDeleteCourse = (index) => {
        setFormData((prev) => {
            const itemToDelete = prev.courses[index];
            let updatedDeleted = [...(prev.deleted_courses || [])];

            // Only track existing (persisted) courses for backend deletion —
            // by the product actually stored, even if the row was edited.
            const persistedId = itemToDelete.original_product_id || itemToDelete.product_id;
            if (itemToDelete.isExisting && persistedId) {
                updatedDeleted.push(persistedId);
            }

            return {
                ...prev,
                courses: prev.courses.filter((_, i) => i !== index),
                deleted_courses: updatedDeleted,
            };
        });
    };

    const handleCourseChange = (index, field, value) => {
        setFormData((prev) => {
            const updated = [...prev.courses];
            updated[index] = { ...updated[index], [field]: value };
            return { ...prev, courses: updated };
        });
    };

    const handlePreviewClick = () => {
        setViewChanges(false);
        const {
            title,
            field_name,
            summary,
            body,
            field_image_success_story,
        } = formData;

        const newErrors = {};
        if (!title.trim()) {
            newErrors.title = "Title field is required.";
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setPreviewFields(false);
            return;
        }

        const cleanedSummary = cleanHtmlOutput(summary);
        const cleanedBody = cleanHtmlOutput(body);

        const hasSummary = cleanedSummary && cleanedSummary.trim() !== '';
        let trimmedHtml = '';

        if (hasSummary) {
            trimmedHtml = cleanedSummary;
        } else if (cleanedBody.includes('<!--break-->')) {
            trimmedHtml = cleanedBody.split('<!--break-->')[0];
        } else {
            const tmp = document.createElement('div');
            tmp.innerHTML = cleanedBody;
            trimmedHtml = '';
        }

        setPreviewData({
            title,
            field_name,
            summary: hasSummary ? cleanedSummary : '',
            trimmed: trimmedHtml,
            body: cleanedBody,
            field_image_success_story,
        });

        setErrors({});
        setPreviewFields(true);
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    const handleViewChangesClick = () => {
        setPreviewFields(false);

        const newErrors = {};
        if (!formData.title?.trim()) {
            newErrors.title = "Title field is required.";
        }
        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) {
            setViewChanges(false);
            window.scrollTo({
            top: 0,
            behavior: "smooth",
            });
            return;
        }
        setViewChanges(true);
        setFormDataSnapshot({
            ...formData,
        });
        setOriginalData(prev => ({
            ...prev,
        }));
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    const getFileIcon = (fileName) => {
        const extension = fileName.split('.').pop().toLowerCase();

        switch (extension) {
            case 'txt':
            return '/basic/web/images/text-plain.png';
            case 'pdf':
            return '/basic/web/images/application-pdf.png';
            case 'docx':
            return '/basic/web/images/x-office-document.png';
            case 'jpg':
            case 'jpeg':
            return '/basic/web/images/image-x-generic.png';
            case 'xls':
            case 'xlsx':
            return '/basic/web/images/x-office-spreadsheet.png';
            case 'csv':
            return '/basic/web/images/text-x-generic.png';
            case 'mp4':
            return '/basic/web/images/video-x-generic.png';
            case 'png':
            return '/basic/web/images/image-x-generic.png';
            default:
            return '/basic/web/images/image-x-generic.png';
        }
    };

    const handleTempImageChange = (e) => {
        const files = Array.from(e.target.files);
        const file = files[0];
        if (!file) return;

        const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
        const maxSize = 128 * 1024 * 1024;
        const errors = [];

        if (!validTypes.includes(file.type)) {
            errors.push('Allowed file types: png, gif, jpg, jpeg.');
        }

        if (file.size > maxSize) {
            errors.push('File must be less than 128 MB.');
        }

        if (errors.length > 0) {
            const errorHTML = `The selected file <em>${file.name}</em> cannot be uploaded. Only files with the following extensions are allowed: <em>png, gif, jpg, jpeg</em>`;
            setImageUploadError(errorHTML);
            e.target.value = '';
            setTempImage(null);
            return;
        }

        setImageUploadError(''); // Clear previous error
        const objectUrl = URL.createObjectURL(file);
        setTempImage({
            file,
            preview: objectUrl
        });
    };
    const handleImageUploadClick = () => {
        if (tempImage) {
            setSelectedImage(tempImage);
            setFormData(prev => ({
            ...prev,
            field_image_success_story: tempImage.file,
            field_delete_image: 0
            }));
            setImageUploadError(''); // Clear error on successful upload
        }
    };

    // Remove image
    const removeImage = () => {
        setSelectedImage(null);
        setTempImage(null);
        setImageUploadError('');
        setFormData(prev => ({
            ...prev,
            field_image_success_story: "",
        }));
    };

    const handleRemoveSavedImage = (type) => {
        setFormData(prev => ({
        ...prev,
            field_image_success_story: '',
            field_delete_image: 1
        }));
        setSelectedImage(null);
        setTempImage(null);
        setImageUploadError('');
    };

    const imageValue = selectedImage ? selectedImage.file : formData.field_image_success_story;
    const fileName =
        imageValue && typeof imageValue === "object" && imageValue.name
        ? imageValue.name
        : typeof imageValue === "string"
        ? imageValue.split("/").pop()
        : "";

    const formatFileSize = (size) => {
        if (size < 1024) return size + " Bytes";
        else if (size < 1024 * 1024) return (size / 1024).toFixed(2) + " KB";
        else return (size / (1024 * 1024)).toFixed(2) + " MB";
    };

    const getImageSrc = (value) => {
        if (!value) return "";
        if (typeof value === "string") return value; // already a URL from backend
        if (value.url) return value.url; // backend returns saved images as { url, name }
        if (value.preview) return value.preview; // wrapper object { file, preview, name }
        if (value.file && value.file instanceof File) return URL.createObjectURL(value.file); // has file
        if (value instanceof File) return URL.createObjectURL(value); // plain File object
        return "";
    };

    const getFileName = (value) => {
        if (!value) return "";
        if (typeof value === "string") {
            return value.split("/").pop(); // extract filename from URL
        }
        if (value.name) return value.name; // File object or wrapper with .name
        if (value.file && value.file.name) return value.file.name; // wrapper {file, preview, name}
        return "";
    };

    const handleEditorChange = (e) => {
        setFormData(prev => ({
            ...prev,
            body: e.target.value
        }));
    };

    const handleChange = (e) => {
        const { name, type, value, checked } = e.target;

        setFormData(prev => {
        if (type === "checkbox" && Array.isArray(prev[name])) {
            return {
            ...prev,
            [name]: checked
                ? [...prev[name], value]
                : prev[name].filter(v => v !== value),
            };
        }
        return {
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        };
        });
    };
    
    const validateForm = () => {
        const newErrors = {};
        if (!formData.title.trim()) {
            newErrors.title = "Title field is required.";
            window.scrollTo(0, 0);
        }
        return newErrors;
    };

    const inputStyle = {
        title: {
        border: errors.title ? '2px solid red' : '1px solid #777'
        }
    };

    const handleSubmit = async (e) => {
       
        e.preventDefault();

        const validationErrors = validateForm();

        setErrors(validationErrors);
        setViewChanges(false);
        setPreviewFields(false);
        setImageUploadError("");

        // If validation fails
        if (Object.keys(validationErrors).length > 0) {
            window.scrollTo({
            top: 0,
            behavior: "smooth",
            });
            return;
        }

        const finalBody = cleanHtmlOutput(formData.body);

        setDisabled(true);
        setButtonText("Saving...");

        // An existing course row whose product was changed must replace the old
        // placement, not add a second one: send it as a new row and queue its
        // original product for deletion (unless that product is still used by
        // another row, e.g. two rows swapped).
        const currentCourses = formData.courses || [];
        const usedProducts = new Set(currentCourses.map((c) => String(c.product_id)));
        const replacedProducts = [];
        const courses = currentCourses.map((c) => {
            if (c.isExisting && c.original_product_id
                && String(c.original_product_id) !== String(c.product_id)) {
                if (!usedProducts.has(String(c.original_product_id))) {
                    replacedProducts.push(c.original_product_id);
                }
                return { ...c, isExisting: false };
            }
            return c;
        });
        const deletedCourses = [...(formData.deleted_courses || [])];
        replacedProducts.forEach((id) => {
            if (!deletedCourses.some((d) => String(d) === String(id))) deletedCourses.push(id);
        });

        const postData = new FormData();
        const updatedFormData = {
            ...formData,
            body: finalBody,
            courses,
            deleted_courses: deletedCourses,
        };

        if (selectedImage?.file) {
            postData.append("field_image_success_story", selectedImage.file);
        }
        postData.append("formData", JSON.stringify(updatedFormData));

        try {
            const response = await fetch(app_url + "successstory/updatepage", { 
            method: "POST",
            body: postData,
            });
            const data = await response.json();
            if (data.data.msg === "Success") {
               
           navigate('/manage-success-stories', { state: { message: data.data.result } });
            }
        } finally {
            setDisabled(false);
            setButtonText("Save");
        }
    };

    const handleDelete = async () => {
        if (window.confirm("Are you sure you want to delete?")) {
            const response = await fetch(
                app_url + "successstory/deletesuccessstory",
                    {
                        method: "POST",
                        headers: {
                        'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ nid: formData.nid }),
                    }
                )
            const data = await response.json();
            if(data.data.msg == "Success") {  
                navigate("/manage-success-stories", { state: { message: data.data.result }}); 
            }
        }
    };

    const isAdmin = userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR);

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div id="main" className={` ${toggle === 2 ? "edit-blog-main" : "smww-agency-news-content-main"}`}>
                    <Helmet>
                        <title>
                            {getPageTitle()}
                        </title>
                    </Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <h1 className="edit-task-title">{getPageHeading()}</h1>
                        <>
                            {(userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR)) &&
                                <ul className="tabs primarya">
                                    <li className= {toggle === 1? "active" : ""} onClick={()=> updateToggle(1)}>
                                        <a style={{cursor: "pointer"}}>View</a>
                                    </li>
                                    
                                    <li className= {toggle === 2? "active" : ""} onClick={()=> updateToggle(2)}>
                                        <a style={{cursor: "pointer"}}>Edit</a>
                                    </li>
                                </ul>
                            }
                        </>

                        <div  className= {toggle === 1 ? "show-content" : "content"}>
                            <ViewSuccessStoryPage
                                title={formData.title}
                                name={formData.field_name}
                                body={formData.body}
                                image={getImageSrc(formData.field_image_success_story)}
                                placements={isAdmin
                                    ? (originalData?.placements || []).map((p) => ({
                                        name: pages.find((item) => String(item['id']) === String(p.placement_page))?.title || `Page ${p.placement_page}`,
                                        sort: p.placement_sort_order,
                                    }))
                                    : null}
                                courses={isAdmin
                                    ? (originalData?.courses || []).map((c) => ({
                                        name: c.product_name,
                                        sort: c.placement_sort_order,
                                    }))
                                    : null}
                            />
                        </div>
                    
                        {(userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR)) &&
                            <div className= {toggle === 2? "show-content" : "content"}>
                                {viewChanges && (
                                    <div className='diff-table-wrapper'>
                                        <table className="diff-table">
                                            <colgroup>
                                                <col className="diff-marker" />
                                                <col className="diff-content" />
                                                <col className="diff-marker" />
                                                <col className="diff-content" />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                <th colSpan="2">Original</th>
                                                <th colSpan="2">Changes</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {!formDataSnapshot || !originalData ? (
                                                    <tr className="no-changes">
                                                        <td className="diff-section-title" colSpan="4">No visible changes</td>
                                                    </tr>
                                                ) : (
                                                    (() => {
                                                        const diffs = [];

                                                        const compareField = (label, oldValue = '', newValue = '') => {
                                                            if (oldValue === newValue) return null;

                                                            const oldLines = (oldValue ?? '').split('\n');
                                                            const newLines = (newValue ?? '').split('\n');
                                                            const maxLines = Math.max(oldLines.length, newLines.length);

                                                            const rows = [
                                                                <tr className="diff-section-title" key={`${label}-title`}>
                                                                <td colSpan="4">Changes to <em>{label}</em></td>
                                                                </tr>
                                                            ];

                                                            for (let i = 0; i < maxLines; i++) {
                                                                const oldLine = (oldLines[i] || '').trim();
                                                                const newLine = (newLines[i] || '').trim();

                                                                if (oldLine !== newLine) {
                                                                    const oldWords = oldLine.split(/\s+/);
                                                                    const newWords = newLine.split(/\s+/);
                                                                    const maxWords = Math.max(oldWords.length, newWords.length);

                                                                    const renderWords = (wordsA, wordsB, isOld) =>
                                                                        wordsA.map((word, idx) => {
                                                                        const matchingWord = wordsB[idx] || '';
                                                                        const changed = word !== matchingWord;

                                                                        return (
                                                                            <span
                                                                            key={`${label}-${isOld ? 'old' : 'new'}-${i}-${idx}`}
                                                                            style={changed ? {
                                                                                color: isOld ? 'red' : 'red',
                                                                                borderRadius: '4px',
                                                                                padding: '0 3px',
                                                                                fontWeight:'bold'
                                                                            } : {}}
                                                                            >
                                                                            {word}
                                                                            {' '}
                                                                            </span>
                                                                        );
                                                                        });

                                                                    rows.push(
                                                                        <tr key={`${label}-${i}`}>
                                                                        <td style={{width:"2px"}}><span>-</span></td>
                                                                        <td className="diff-removed">{renderWords(oldWords, newWords, true)}</td>
                                                                        <td style={{width:"2px"}}><span>+</span></td>
                                                                        <td className="diff-added">{renderWords(newWords, oldWords, false)}</td>
                                                                        </tr>
                                                                    );
                                                                }
                                                            }

                                                            return rows;
                                                        };

                                                        const compareFiles = (label, oldFiles = [], newFiles = []) => {
                                                            const oldList = Array.isArray(oldFiles)
                                                                ? oldFiles.map(f => f.name).join(', ')
                                                                : '';

                                                            const newList = Array.isArray(newFiles)
                                                                ? newFiles.map(f => f.name).join(', ')
                                                                : '';

                                                            // If no difference, return an empty array (safe + iterable)
                                                            if (oldList === newList) {
                                                                return [];
                                                            }
                                                            // Otherwise return whatever diff UI compareField creates
                                                            return [compareField(label, oldList, newList)];
                                                        };


                                                        diffs.push(...(compareField('Title', originalData.title, formDataSnapshot.title) || []));
                                                        diffs.push(...(compareField('Name', originalData.field_name, formDataSnapshot.field_name) || []));
                                                        diffs.push(...(compareField('Summary', originalData.summary, formDataSnapshot.summary) || []));
                                                        diffs.push(...(compareField('Body', originalData.body, formDataSnapshot.body) || []));

                                                        const originalImage = originalData.field_image_success_story || "";
                                                        const newImage = formDataSnapshot.field_image_success_story || "";
                                                        // if (originalData.field_image_success_story !== formDataSnapshot.field_image_success_story) {
                                                        if (originalImage !== newImage) {
                                                            diffs.push(
                                                                <tr className="diff-section-title" key="preview-image-title">
                                                                    <td colSpan="4">Changes to <em>Image</em></td>
                                                                </tr>,
                                                                <tr key="preview-image-diff">
                                                                    <td><span>-</span></td>
                                                                    <td className="diff-removed">
                                                                        {originalData.field_image_success_story && getFileName(originalData.field_image_success_story)}
                                                                    </td>
                                                                    <td><span>+</span></td>
                                                                    <td className="diff-added" style={{ color: 'red', fontWeight: 'bold' }}>
                                                                        {formDataSnapshot.field_image_success_story && getFileName(formDataSnapshot.field_image_success_story)}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        }

                                                        // COURSE section: pair each saved course with the row now editing it
                                                        // (via original_product_id), so added / removed / re-sorted / swapped
                                                        // courses each show on their own line instead of shifting the rest.
                                                        // Each pair becomes one aligned line, diffed with the same line/word
                                                        // highlighting as the fields above ("" = added or removed).
                                                        const courseLine = (c) => {
                                                            if (!c || !c.product_id) return '';
                                                            const name = (courses.find((p) => String(p.id) === String(c.product_id)) || {}).product_name
                                                                || c.product_name || `Course ${c.product_id}`;
                                                            return `${name} (Sort order: ${c.placement_sort_order})`;
                                                        };
                                                        const savedCourses = originalData.courses || [];
                                                        const editedCourses = (formDataSnapshot.courses || []).filter((c) => c.product_id);
                                                        const coursePairs = savedCourses.map((saved) => [
                                                            saved,
                                                            editedCourses.find((c) => c.isExisting
                                                                && String(c.original_product_id ?? c.product_id) === String(saved.product_id)),
                                                        ]);
                                                        editedCourses
                                                            .filter((c) => !coursePairs.some(([, cur]) => cur === c))
                                                            .forEach((c) => coursePairs.push([null, c]));
                                                        diffs.push(...(compareField(
                                                            'Course',
                                                            coursePairs.map(([saved]) => courseLine(saved)).join('\n'),
                                                            coursePairs.map(([, cur]) => courseLine(cur)).join('\n')
                                                        ) || []));

                                                        return diffs.length > 0 ? diffs : (
                                                            <tr className="no-changes">
                                                                <td className="diff-section-title" colSpan="4">No visible changes</td>
                                                            </tr>
                                                        );
                                                    })()
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                                {PreviewFields && (<>
                                    <div
                                        className="messages status"
                                        style={{
                                            background: `#f0f8eb url("/basic/web/images/message-ok.png") no-repeat`,
                                            backgroundPosition: '10px 10px',
                                        }}
                                    >
                                        The trimmed version of your post shows what your post looks like when promoted
                                        to the main page or when exported for syndication.
                                        <span>
                                            You can insert the delimiter &lt;!--break--&gt; (without the quotes) to
                                            fine-tune where your post gets split.
                                        </span>
                                    </div>

                                    <div className="preview-container">
                                        {/* Trimmed version */}
                                        {/* Same markup as Manage Email Letters' trimmed preview:
                                            linked title, teaser blocks, Read more link. */}
                                        <div className="preview-trimmed">
                                            <h4 className="preview-heading">
                                                <span className="preview-square"></span> Preview trimmed version
                                            </h4>
                                            <div className="email-teaser">
                                                <h2 className="email-title">
                                                    <a href={"/" + (page?.url_slug || formData.url_alias || "")}>{previewData?.title}</a>
                                                </h2>
                                                <div className="email-teaser-block1">
                                                    <div className="email-teaser-block2">
                                                        {previewData.trimmed && (
                                                            <div
                                                                className="preview-body-content"
                                                                dangerouslySetInnerHTML={{ __html: previewData.trimmed }}
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="read-more-link">
                                                    <a href={"/" + (page?.url_slug || formData.url_alias || "")}>Read more</a>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Full version */}
                                        <div className="preview-full">
                                            <h4 className="preview-heading">
                                                Preview full version
                                            </h4>
                                            <div className="email-teaser">
                                                <h2 className="email-title"></h2>
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                    __html: previewData.body || '',
                                                    }}
                                                />
                                                <div className="email-meta">
                                                    {previewData.field_name && (
                                                        <p><strong>Name:</strong> {previewData.field_name}</p>
                                                    )}
                                                    {previewData.field_image_success_story && (
                                                        <div>
                                                            <strong>Image:</strong><br />
                                                            <img 
                                                            src={getImageSrc(previewData.field_image_success_story)} 
                                                            alt="Preview" 
                                                            style={{ height: "100px", width: "100px", marginTop: "5px" }} 
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>)}

                                <div className="agency-news-create-container">
                                    {Object.values(errors).some(msg => !!msg) && (
                                        <div
                                            className="set-message-error error-message-padding"
                                            style={{
                                            background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`
                                            }}
                                        >
                                            <ul>
                                                {Object.values(errors)
                                                .filter(msg => !!msg)
                                                .map((msg, index) => (
                                                    <li key={index}>{msg}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                    <form onSubmit={handleSubmit}>
                                        <div>
                                            <div className="form-item">
                                                <label htmlFor="edit-title">
                                                    Title  
                                                    <span className="form-required" title="This field is required.*">*</span>
                                                </label>
                                                <input
                                                    type="text" 
                                                    id="edit-title" 
                                                    name="title"
                                                    size={60}
                                                    maxLength={255}
                                                    onChange={handleChange} 
                                                    value={formData.title}
                                                    style={inputStyle.title}
                                                />
                                            </div>

                                            <div className="form-item">
                                                <label htmlFor="edit-field-name">
                                                    Name
                                                </label>
                                                <input 
                                                    className="text-full form-text" 
                                                    type="text" 
                                                    id="edit-field-name" 
                                                    name="field_name" 
                                                    size={60} 
                                                    maxLength={255}
                                                    value={formData.field_name}
                                                    onChange={handleChange}
                                                />
                                            </div>

                                            <div>
                                                <label>Image</label>
                                                {imageUploadError && (
                                                    <div
                                                        className="set-message-error error-message-padding"
                                                        style={{
                                                        background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`
                                                        }}
                                                    >
                                                        <div 
                                                            style={{ color: '#8c2e0b',
                                                                backgroundColor: '#fef5f1',
                                                                marginBottom: '10px', 
                                                                width: '80%',
                                                                borderRadius: '5px' 
                                                            }}
                                                            dangerouslySetInnerHTML={{ __html: imageUploadError }}
                                                            >                           
                                                        </div>
                                                    </div>
                                                )}
                                                {selectedImage ? (
                                                    // Case 1: New image selected
                                                    <>
                                                        <div className="edit-agent-image-container">
                                                            <img alt="Uploaded" src={selectedImage.preview} width="90" height="100" />
                                                            <div className="image-info">
                                                                <img
                                                                    className="file-icon"
                                                                    alt="File icon"
                                                                    src={getFileIcon(selectedImage.file.name)}
                                                                />
                                                                <a
                                                                    href={selectedImage.preview}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="image-name-link"
                                                                >
                                                                    {selectedImage.file.name}
                                                                </a>
                                                                <span className="image-size">
                                                                    ({(selectedImage.file.size / 1024).toFixed(2)} KB)
                                                                </span>
                                                            </div>
                                                        </div>

                                                        <input
                                                            type="button"
                                                            value="Remove"
                                                            className="form-submit"
                                                            onClick={removeImage}
                                                        />
                                                    </>
                                                ) : formData.field_image_success_story ? (
                                                    // Case 2: Image already saved (URL string from backend)
                                                    <>
                                                        <div className="edit-scout-report-image-container">
                                                            <img
                                                                alt="Uploaded"
                                                                src={getImageSrc(formData.field_image_success_story)}
                                                                width="90"
                                                                height="100"
                                                            />
                                                            <div className="image-info">
                                                                <a
                                                                    href={getImageSrc(formData.field_image_success_story)}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="image-name-link"
                                                                >
                                                                    {fileName}
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <input
                                                            type="button"
                                                            value="Remove"
                                                            className="form-submit"
                                                            onClick={handleRemoveSavedImage}
                                                        />
                                                    </>
                                                ) : (
                                                    // Case 3: No image yet → show upload input
                                                    <div>
                                                        <input
                                                            type="file"
                                                            id="edit-agent-photo-upload"
                                                            name="field_image_success_story"
                                                            accept="image/*"
                                                            onChange={handleTempImageChange}
                                                        />
                                                        <input
                                                            type="button"
                                                            value="Upload"
                                                            className="form-submit"
                                                            onClick={handleImageUploadClick}
                                                        />
                                                    </div>
                                                )}

                                                {!formData.field_image_success_story && !selectedImage && (
                                                    <div className="description">
                                                        Files must be less than <b>128 MB</b>.<br />
                                                        Allowed file types: <b>png gif jpg jpeg</b>.
                                                    </div>
                                                )}
                                                <div style={{clear: "both"}}></div>
                                            </div>

                                            <div>
                                                <div>
                                                    {showSummary && (
                                                        <div className="form-item">
                                                            <label htmlFor="create_summary">
                                                                Summary <span>(<a className="" href="#" onClick={(e) => { e.preventDefault(); setShowSummary(false); }}>Hide Summary</a>)</span>
                                                            </label>
                                                            <>
                                                                <Editor 
                                                                value={formData.summary} 
                                                                onChange={(e) => {
                                                                    const newValue = e?.target?.value || '';
                                                                    setFormData((prev) => ({ ...prev, summary: newValue }));
                                                                }}
                                                                />
                                                            </>
                                                            <div className="description">Leave blank to use trimmed value of full text as the summary.</div>
                                                        </div>
                                                    )}
                                            
                                                    <div className="form-item">
                                                        <label htmlFor="create_body">
                                                            Body
                                                            {!showSummary && (
                                                                <span>
                                                                    (<a href="#" onClick={(e) => { e.preventDefault(); setShowSummary(true); }}>
                                                                        Edit Summary
                                                                    </a>)
                                                                </span>
                                                            )}
                                                        </label>
                                                        <>
                                                            {useRichEditor ? (
                                                                <> 
                                                                    <Editor 
                                                                        containerProps={{ style: { resize: 'vertical', height:'300px' } }} 
                                                                        value={formData.body} 
                                                                        onChange={handleEditorChange}

                                                                    />  
                                                                    <a href="#" onClick={(e) => { e.preventDefault(); setUseRichEditor(false); }}>
                                                                        Switch to plain text editor
                                                                    </a>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <textarea
                                                                        id="create_body"
                                                                        rows="20"
                                                                        value={formData.body} 
                                                                        // onChange={e => onEditorChange('body', e.target.value)}
                                                                        onChange={(e) => setFormData((prev) => ({ ...prev, body: e.target.value })) } 
                                                                    />
                                                                    <div 
                                                                        className="grippie" 
                                                                        style={{ background: `#eee url("/basic/web/images/grippie.png") no-repeat center 2px` }}
                                                                    >
                                                                    </div>
                                                                    <a href="#" onClick={(e) => { e.preventDefault(); setUseRichEditor(true); }}>
                                                                        Switch to rich text editor
                                                                    </a>
                                                                </>
                                                            )}
                                                        </>
                                                    </div>
                                                </div>

                                                <fieldset 
                                                    className="form-wrapper" 
                                                    style={{
                                                        border: "1px solid #ccc", 
                                                        padding: "15px 20px", 
                                                        marginBottom: "15px",
                                                        fontFamily: "sans-serif"
                                                    }}
                                                >

                                                    {/* COURSE section. Courses = entity_placement rows with product_id.
                                                        Page placements are no longer editable here; any existing
                                                        ones still ride along in formData unchanged on save. */}
                                                    <div className="editprofile-fieldset-wrapper">
                                                        <label>COURSE</label>
                                                        <table
                                                            style={{
                                                                width: "100%",
                                                                borderCollapse: "collapse",
                                                                backgroundColor: "white",
                                                                border: "1px solid #ccc",
                                                                fontSize: "11px"
                                                            }}
                                                            className="courses-table"
                                                        >
                                                            <thead>
                                                                <tr style={{ backgroundColor: "#e1e2dc", borderBottom: "1px solid #ccc" }}>
                                                                    <th style={{
                                                                        width: '70%',
                                                                        padding: '6px 10px',
                                                                        textAlign: 'left',
                                                                        fontWeight: 'bold',
                                                                        color: '#333',
                                                                        textTransform: 'uppercase',
                                                                        borderRight: '1px solid #ccc'
                                                                    }}>
                                                                        Course
                                                                    </th>
                                                                    <th style={{
                                                                        width: '15%',
                                                                        padding: '6px 10px',
                                                                        textAlign: 'left',
                                                                        fontWeight: 'bold',
                                                                        color: '#333',
                                                                        textTransform: 'uppercase',
                                                                        borderRight: '1px solid #ccc'
                                                                    }}>
                                                                        Sort Order
                                                                    </th>
                                                                    <th style={{
                                                                        width: '15%',
                                                                        padding: '6px 10px',
                                                                        textAlign: 'center',
                                                                        fontWeight: 'bold',
                                                                        color: '#333',
                                                                        textTransform: 'uppercase'
                                                                    }}>
                                                                        Delete
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {(formData.courses || []).map((course, index) => (
                                                                    <tr key={index} style={{ borderBottom: index < formData.courses.length - 1 ? "1px solid #ccc" : "none" }}>
                                                                        {/* Course Select Column */}
                                                                        <td style={{ padding: '10px', borderRight: '1px solid #ccc' }}>
                                                                            <select
                                                                                className="course-select"
                                                                                name={`course_product_${index}`}
                                                                                value={course.product_id}
                                                                                onChange={(e) =>
                                                                                    handleCourseChange(index, 'product_id', e.target.value)
                                                                                }
                                                                                style={{
                                                                                    width: "100%",
                                                                                    padding: "4px",
                                                                                    border: "1px solid #ccc",
                                                                                    borderRadius: "2px",
                                                                                    fontSize: "12px",
                                                                                    boxSizing: "border-box"
                                                                                }}
                                                                            >
                                                                                <option value="">Select a course</option>
                                                                                {courses.length > 0 && (
                                                                                    <>
                                                                                        {courses.map((item) => (
                                                                                            <option key={item['id']} value={item['id']}>
                                                                                                {item['product_name']}
                                                                                            </option>
                                                                                        ))}
                                                                                    </>
                                                                                )}
                                                                            </select>
                                                                        </td>

                                                                        {/* Sort Order Select Column */}
                                                                        <td style={{ padding: '10px', textAlign: 'center', borderRight: '1px solid #ccc' }}>
                                                                            <select
                                                                                name={`course_sort_order_${index}`}
                                                                                className="adduser-form-select"
                                                                                value={course.placement_sort_order}
                                                                                onChange={(e) =>
                                                                                    handleCourseChange(index, 'placement_sort_order', e.target.value)
                                                                                }
                                                                                style={{
                                                                                    width: "100%",
                                                                                    maxWidth: "60px",
                                                                                    padding: "4px",
                                                                                    border: "1px solid #ccc",
                                                                                    borderRadius: "2px",
                                                                                    fontSize: "12px"
                                                                                }}
                                                                            >
                                                                                {[...Array(Math.max(50, Number(course.placement_sort_order) || 0))].map((_, i) => (
                                                                                    <option key={i + 1} value={i + 1}>
                                                                                        {i + 1}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        </td>

                                                                        {/* Delete Button Column */}
                                                                        <td style={{ padding: '10px', textAlign: 'center' }}>
                                                                            <button
                                                                                type="button"
                                                                                className='quick-links-reg-button form-submit'
                                                                                onClick={() => handleDeleteCourse(index)}
                                                                            >
                                                                                Delete
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>

                                                        {/* Add Course Link */}
                                                        <div style={{ marginTop: "12px" }}>
                                                            <a
                                                                className="add-course-link"
                                                                href="#"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    handleAddCourse();
                                                                }}
                                                                style={{
                                                                    color: "#0071B8",
                                                                    textDecoration: "none",
                                                                    fontWeight: "bold",
                                                                    fontSize: "12px"
                                                                }}
                                                                onMouseOver={(e) => e.currentTarget.style.textDecoration = "underline"}
                                                                onMouseOut={(e) => e.currentTarget.style.textDecoration = "none"}
                                                            >
                                                                + Add
                                                            </a>
                                                        </div>
                                                    </div>
                                                </fieldset>

                                                <div className="form-item">
                                                    <label htmlFor="edit-path-alias">
                                                        URL alias
                                                    </label>
                                                    <input
                                                        type="text" 
                                                        id="edit-path-alias" 
                                                        name="url_alias"
                                                        onChange={handleChange} 
                                                        value={formData.url_alias}
                                                
                                                    />
                                                    <p className="description" style={{marginTop: "5px"}}>Optionally specify an alternative URL by which this content can be accessed. For example, type "about" when writing an about page. 
                                                    Use a relative path and don't add a trailing slash or the URL alias won't work.</p>
                                                </div>

                                            </div>
                                            <div className="form-actions form-wrapper" id="create-actions">
                                                <input type="submit" id="create-submit" name="" value="Save" className="form-submit" />&nbsp;&nbsp;
                                                <input
                                                    type="button"
                                                    id="edit-task-preview-changes"
                                                    value="View changes"
                                                    className="form-submit"
                                                    onClick={handleViewChangesClick}
                                                />&nbsp;&nbsp;
                                                <input type="button" id="edit-task-delete" name="" value="Delete" className="form-submit" onClick={handleDelete} />
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        }
                    </div>
                    <div className="right"></div>
                </div>
            )}
        </>
    );
};
export default EditSuccessStoryPage;